// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetProductThumbnailRequestModel from '../../model/get-product-thumbnail-request-model';
import GetProductThumbnailRequestDTO from '../dto/get-product-thumbnail-request-dto';

export default abstract class GetProductThumbnailRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetProductThumbnailRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.width = data.width;
      this.height = data.height;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;
  /**
  * @type {int32}
  */
  'width'?: number;
  /**
  * @type {int32}
  */
  'height'?: number;

  static toModel(dto: DeepPartial<GetProductThumbnailRequestDTO>): GetProductThumbnailRequestModel;
  static toModel(dto: DeepPartial<GetProductThumbnailRequestDTO> | undefined | null): GetProductThumbnailRequestModel | undefined;
  static toModel(dto: DeepPartial<GetProductThumbnailRequestDTO> | undefined | null): GetProductThumbnailRequestModel | undefined {
    return dto ? new GetProductThumbnailRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetProductThumbnailRequestModel> | GetProductThumbnailRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
      'width': unwrapped.width,
      'height': unwrapped.height,
    } as GetProductThumbnailRequestDTO;
  }
}
